import React from 'react'
import { SxProps, TextField } from '@mui/material'
import { t } from 'i18next'

type HoursThresholdProps = {
  value: string
  setValue: (value: string) => void
  sxProps?: SxProps
}

const NumberInputHoursThreshold = ({ value, setValue, sxProps }: HoursThresholdProps) => {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value

    if (newValue === '' || (/^\d$/.test(newValue) && +newValue >= 0 && +newValue <= 5)) {
      setValue(newValue)
    }
  }

  return (
    <TextField
      sx={{ width: '40%', ...sxProps }}
      label={`${t('components.settingsDialog.autoCollapseThreshold')} (0-5)`}
      aria-label={t('components.settingsDialog.autoCollapseThreshold')}
      size="small"
      value={value}
      onChange={handleChange}
      inputProps={{
        inputMode: 'numeric',
        pattern: '[0-5]*',
      }}
    />
  )
}

export default NumberInputHoursThreshold
